
export const SEARCH_APPLICATION_FILTERS_INITIAL_VALUES = {
    applicationIdentifyingCode: '',
    name: '',
    surname: '',
    companyName: '',
    city: '',
    newPartner: null,
    currentStatus: null,
    areaOfApplicationStatus: null,
    postalCode: '',
    region: null,
    vatNumber:'',
    siren:'',
    tenants: null,
    dealers: null,
}